interface EventHelperDetails {
  id: string;
  title: string;
  start_date: string;
  start_time: string;
  end_date?: string;
  end_time?: string;
  location?: string;
  type: string;
  category: string;
  modality: string;
  host_name: string;
  image_url?: string;
  base_url: string;
  manager_token: string; // Token for authentication
}

export function getEventHelperEmailTemplate(event: EventHelperDetails) {
  // Generate accept link with auth token
  const acceptUrl = `${event.base_url}/events/${event.id}/helping?token=${event.manager_token}`;
  
  const subject = `Te invitaron a ayudar en: ${event.title}`;
  
  const formattedDate = new Date(event.start_date).toLocaleDateString('es-AR', {
    weekday: 'long', 
    month: 'long', 
    day: 'numeric',
    year: 'numeric'
  });
  
  const body = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${subject}</title>
      <style>
        body {
          font-family: 'Helvetica Neue', Arial, sans-serif;
          line-height: 1.6;
          color: #333;
          margin: 0;
          padding: 0;
          background-color: #f9f9f9;
        }
        .email-container {
          max-width: 600px;
          margin: 0 auto;
          background-color: #ffffff;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 4px 8px rgba(0,0,0,0.05);
        }
        .header {
          background-color: #4C66EF;
          padding: 30px 0;
          text-align: center;
          color: white;
        }
        .header h1 {
          margin: 0;
          color: white;
          font-size: 24px;
        }
        .content {
          padding: 30px;
        }
        .event-image {
          width: 100%;
          height: auto;
          border-radius: 6px;
          margin-bottom: 20px;
        }
        h2 {
          color: #333;
          margin-top: 0;
        }
        .event-details {
          background-color: #f5f7fa;
          padding: 20px;
          border-radius: 6px;
          margin: 20px 0;
        }
        .detail-row {
          display: flex;
          margin-bottom: 15px;
        }
        .detail-label {
          width: 120px;
          font-weight: bold;
          color: #666;
        }
        .detail-value {
          flex: 1;
        }
        .cta-button {
          display: inline-block;
          background-color: #4C66EF;
          color: white !important;
          text-decoration: none;
          padding: 14px 30px;
          border-radius: 6px;
          font-weight: bold;
          margin-top: 20px;
          text-align: center;
        }
        .secondary-link {
          display: block;
          margin-top: 15px;
          color: #666;
          text-align: center;
        }
        .footer {
          padding: 20px 30px;
          text-align: center;
          font-size: 12px;
          color: #999;
          border-top: 1px solid #eee;
        }
        .helper-benefits {
          margin: 25px 0;
          padding: 0;
        }
        .helper-benefits li {
          margin-bottom: 10px;
          list-style-type: none;
          padding-left: 30px;
          position: relative;
        }
        .helper-benefits li:before {
          content: "✓";
          position: absolute;
          left: 0;
          color: #4C66EF;
          font-weight: bold;
        }
        @media only screen and (max-width: 500px) {
          .content {
            padding: 20px;
          }
          .detail-row {
            flex-direction: column;
          }
          .detail-label {
            width: 100%;
            margin-bottom: 5px;
          }
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="header">
          <h1>INVITACIÓN PARA AYUDAR EN EL EVENTO</h1>
        </div>
        <div class="content">
          <h2>¡Fuiste invitado a ayudar en un evento!</h2>
          <p>Hola,</p>
          <p>${event.host_name} te invitó a colaborar en el siguiente evento:</p>
          
          ${event.image_url ? `<img src="${event.image_url}" alt="${event.title}" class="event-image">` : ''}
          
          <h2>${event.title}</h2>
          
          <div class="event-details">
            <div class="detail-row">
              <div class="detail-label">Fecha:</div>
              <div class="detail-value">${formattedDate}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">Hora:</div>
              <div class="detail-value">${event.start_time}${event.end_time ? ` - ${event.end_time}` : ''}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">Lugar:</div>
              <div class="detail-value">${event.location || 'Online'}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">Tipo:</div>
              <div class="detail-value">${event.type}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">Categoría:</div>
              <div class="detail-value">${event.category}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">Modalidad:</div>
              <div class="detail-value">${event.modality}</div>
            </div>
          </div>
          
          <p>Como asistente del evento, vas a poder:</p>
          
          <ul class="helper-benefits">
            <li>Apoyar el armado y la logística</li>
            <li>Ayudar con el registro y el check-in</li>
            <li>Colaborar en networking y actividades</li>
            <li>Ganar experiencia detrás de escena</li>
            <li>Conectar con otros ayudantes y asistentes</li>
          </ul>
          
          <center>
            <a href="${acceptUrl}" class="cta-button">Aceptar y ayudar</a>
          </center>
          
          <p class="secondary-link">Este enlace te llevará al panel de ayudantes.</p>
        </div>
        <div class="footer">
          <p>Esta invitación fue enviada por Punta Tech Meetup. Si creés que la recibiste por error, ignorá este correo.</p>
        </div>
      </div>
    </body>
    </html>
  `;

  return { subject, body };
}